var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.laoding,
          expression: "laoding",
        },
      ],
      attrs: {
        visible: _vm.dialogVisible,
        width: "1340px",
        title: `${!_vm.type ? "应收" : "应付"}审核费用`,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        top: "1%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("单号")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.rowData.serviceNo)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("客户")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.rowData.companyName)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("业务类型")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.rowData.companyName)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("参考单号1")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.rowData.referenceNumber)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("参考单号2")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.rowData.referenceNumber2)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("需求补充")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.rowData.demandAdditional)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("创建人")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.rowData.createdName)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("创建时间")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.rowData.createdOn)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("进入时间")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.rowData.entryTime)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("附件数")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.rowData.attachmentCount)),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "item", staticStyle: { display: "flex" } },
            [
              _c("el-input-number", {
                ref: "inputNumber",
                staticStyle: { width: "125px" },
                attrs: {
                  min: 0,
                  max: 100,
                  disabled:
                    _vm.rowData.status !== 3 && _vm.rowData.status !== 4,
                },
                on: {
                  focus: function ($event) {
                    return _vm.$refs.inputNumber.select()
                  },
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.newAdd.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.entry,
                  callback: function ($$v) {
                    _vm.entry = $$v
                  },
                  expression: "entry",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "btn",
                  staticStyle: { width: "60px", "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.newAdd },
                },
                [_vm._v(" 增加 ")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "data" },
          [
            _c("VisTableComponents", {
              ref: "visTable",
              staticStyle: { "max-height": "550px" },
              attrs: {
                componentId: "visTable",
                options: {
                  ..._vm.tableData,
                  headerStyle: _vm.headerStyle,
                  bodyStyle: _vm.bodyStyle,
                  columns: _vm.columns,
                },
              },
              on: { editChange: _vm.editChange, iconClick: _vm.iconClick },
            }),
            _c("div", { staticClass: "total" }, [
              _c("span", { staticClass: "total-item" }, [
                _vm._v(" 共 "),
                _c("span", { staticClass: "num" }, [
                  _vm._v(" " + _vm._s(_vm.tableData.data.length) + " "),
                ]),
                _vm._v(" 条 "),
              ]),
              _c("span", { staticClass: "total-item" }, [
                _vm._v(" 应收合计 "),
                _c("span", { staticClass: "num" }, [
                  _vm._v(
                    " $" + _vm._s(_vm.receivableTotalAmount.toFixed(2)) + " "
                  ),
                ]),
              ]),
              _c("span", { staticClass: "total-item" }, [
                _vm._v(" 应付合计 "),
                _c("span", { staticClass: "num" }, [
                  _vm._v(
                    " $" + _vm._s(_vm.payableTotalAmount.toFixed(2)) + " "
                  ),
                ]),
              ]),
              _c("span", { staticClass: "total-item" }, [
                _vm._v(" 利润 "),
                _c("span", { staticClass: "num" }, [
                  _vm._v(
                    " $" +
                      _vm._s(
                        (
                          _vm.receivableTotalAmount - _vm.payableTotalAmount
                        ).toFixed(2)
                      ) +
                      " "
                  ),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "debounce-click",
                  rawName: "v-debounce-click",
                  value: { value: _vm.ok, args: [0] },
                  expression: "{ value: ok, args: [0] }",
                },
              ],
              staticClass: "ok flex_c_c",
            },
            [_vm._v(" 保存 ")]
          ),
          (_vm.type === 1 && _vm.rowData.status > 3) || _vm.rowData.status === 3
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "debounce-click",
                      rawName: "v-debounce-click",
                      value: { value: _vm.ok, args: [1] },
                      expression: "{ value: ok, args: [1] }",
                    },
                  ],
                  staticClass: "ok flex_c_c",
                },
                [_vm._v(" 保存并审核 ")]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }